import { useEffect, useState } from 'react'

import Api from 'services/api'
import { SystemComponent } from 'types/SystemComponent'

const useSystemComponents = (deviceId: string, refresh: number) => {
  const [systemComponents, setSystemComponents] = useState<Array<SystemComponent> | null>(null)
  const [areSystemComponentsLoaded, setAreSystemComponentsLoaded] = useState(false)

  useEffect(() => {
    setAreSystemComponentsLoaded(false)

    Api.SystemComponents.get(deviceId)
      .then((res: Array<SystemComponent> | null) => {
        setSystemComponents((res))
      }).catch(() => {
        setSystemComponents(null)
      }).finally(() => {
        setAreSystemComponentsLoaded(true)
      })
  }, [deviceId, refresh])

  return { systemComponents, areSystemComponentsLoaded }
}

export default useSystemComponents
